// src/components/meeting/panels/CreatePanel.jsx
import MeetingForm from "../MeetingForm";

export default function CreatePanel({
  projectId,
  selectedDate,
  existingCompositeKeySet,
  onSaved,
  onClose,
}) {
  return (
    <MeetingForm
      mode="create"
      projectId={projectId}
      initialDate={selectedDate}
      existingCompositeKeySet={existingCompositeKeySet}
      originalCompositeKey={null}
      onCancel={onClose}
      onSaved={onSaved}
    />
  );
}
